import { createMarketplaceHttpClient } from "../marketplaceHttpClient";

/**
 * Contrats de prévente vus par l'acheteur (page /producers).
 *
 *   Navigateur :3000 → Gateway :8080 → agri-product-platform :1997
 *   GET  /marketplace/presale-contracts/purchased?country=TG
 *   GET  /marketplace/presale-contracts/{id}?country=TG                 détail, texte, paiements, séquestre
 *   POST /marketplace/presale-contracts/{id}/sign?country=TG            { termsSha256 }
 *   POST /marketplace/presale-contracts/{id}/cancel?country=TG          { reason }
 *   POST /marketplace/presale-contracts/{id}/delivery/confirm?country=TG
 *   POST /marketplace/presale-contracts/{id}/delivery/contest?country=TG { reason }
 *   POST /marketplace/presale-contracts/{id}/payments?country=TG        Idempotency-Key, { method, operator, phoneNumber }
 *
 * `country` est le pays du producteur (base où le contrat est enregistré). Montants, devise,
 * avance et commission viennent du contrat figé côté backend : le frontend n'en calcule aucun.
 */
const api = createMarketplaceHttpClient();

const BASE = "/marketplace/presale-contracts";

export const listPurchasedContracts = async (country) => {
    const { data } = await api.get(`${BASE}/purchased`, { params: { country } });
    return Array.isArray(data) ? data : [];
};

/** @returns {Promise<{contract: object, termsText: string, termsSha256: string, payments: object[], escrowOrders: object[]}>} */
export const getContract = async (country, contractId) => {
    const { data } = await api.get(`${BASE}/${contractId}`, { params: { country } });
    return data;
};

/** Signature de l'acheteur sur l'empreinte du texte qu'il a lu. */
export const signContract = async (country, contractId, termsSha256) => {
    const { data } = await api.post(`${BASE}/${contractId}/sign`, { termsSha256 }, { params: { country } });
    return data;
};

export const cancelContract = async (country, contractId, reason) => {
    const { data } = await api.post(`${BASE}/${contractId}/cancel`, { reason: reason || null }, { params: { country } });
    return data;
};

export const confirmDelivery = async (country, contractId) => {
    const { data } = await api.post(`${BASE}/${contractId}/delivery/confirm`, null, { params: { country } });
    return data;
};

export const contestDelivery = async (country, contractId, reason) => {
    const { data } = await api.post(`${BASE}/${contractId}/delivery/contest`, { reason: reason || null },
        { params: { country } });
    return data;
};

/**
 * Paie la somme attendue (avance, puis solde) : la même clé reprend la même tentative.
 * @param {{method: "MOBILE_MONEY"|"CARD", operator?: string, phoneNumber?: string}} payment
 */
export const payContract = async (country, contractId, { method, operator, phoneNumber }, idempotencyKey) => {
    const { data } = await api.post(`${BASE}/${contractId}/payments`, {
        method,
        operator: method === "MOBILE_MONEY" ? operator : null,
        phoneNumber: method === "MOBILE_MONEY" ? phoneNumber : null,
    }, { params: { country }, headers: { "Idempotency-Key": idempotencyKey } });
    return data;
};

const presaleContractApi = {
    listPurchasedContracts, getContract, signContract, cancelContract, confirmDelivery, contestDelivery, payContract,
};

export default presaleContractApi;
